@file:OptIn(InternalResourceApi::class)

package snakesworld.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/snakesworld.shared.generated.resources/"

@delegate:ResourceContentHash(-445_044_810)
internal val Res.font.zcool_kuaile_regular: FontResource by lazy {
      FontResource("font:zcool_kuaile_regular", setOf(
        ResourceItem(setOf(), "${MD}font/zcool_kuaile_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("zcool_kuaile_regular", Res.font.zcool_kuaile_regular)
}
